<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Modifier le contact</h2>
    <p class="page-subtitle">Mettez à jour les informations de votre contact</p>
  </div>
  <a routerLink="/contacts" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    @if (loadingContact()) {
      <div class="loading-state">Chargement du contact...</div>
    } @else {
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="modern-form">
        <div class="form-section">
          <h3 class="section-title">Informations du contact</h3>
          <div class="form-row">
            <div class="form-group col">
              <label for="nom">NOM</label>
              <input type="text" id="nom" formControlName="nom" class="form-control" placeholder="ex: Dupont">
            </div>
            <div class="form-group col">
              <label for="prenom">PRÉNOM</label>
              <input type="text" id="prenom" formControlName="prenom" class="form-control" placeholder="ex: Jean">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <label for="telephone">TÉLÉPHONE</label>
              <input type="text" id="telephone" formControlName="telephone" class="form-control" placeholder="ex: 0102030405">
            </div>
            <div class="form-group col">
              <label for="email">ADRESSE EMAIL</label>
              <input type="email" id="email" formControlName="email" class="form-control" placeholder="ex: jean.dupont&#64;exemple.com">
            </div>
          </div>
        </div>

        @if (errorMessage()) {
          <div class="error-banner">{{ errorMessage() }}</div>
        }

        <div class="form-actions">
          <div class="form-actions-left">
            @if (canDelete()) {
              <button type="button" (click)="onDelete()" class="btn btn-danger-outline" [disabled]="isLoading()">
                Supprimer
              </button>
            } @else {
              <button type="button" (click)="onArchive()" class="btn btn-warning-outline" [disabled]="isLoading() || contactForm.get('archived')?.value">
                {{ contactForm.get('archived')?.value ? 'Contact Archivé' : 'Archiver' }}
              </button>
            }
          </div>
          <div class="form-actions-right">
            <button type="button" routerLink="/contacts" class="btn btn-outline">Annuler</button>
            <button type="submit" [disabled]="contactForm.invalid || isLoading()" class="btn btn-primary">
              {{ isLoading() ? 'Mise à jour en cours...' : 'Enregistrer les modifications' }}
            </button>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-confirm-dialog
  *ngIf="showDeleteModal()"
  [title]="'Supprimer le contact'"
  [message]="'Êtes-vous sûr de vouloir supprimer définitivement ce contact ?'"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>
